var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expand-x-transition',[_c('v-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"ma-0 overlay",style:(_vm.background)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }